export default __webpack_public_path__ + "static/media/seo-services-img2.c40bf0c6.png";